var map = {
	"./EraseLine.svg": 90651,
	"./EraseObj.svg": 64928,
	"./add.svg": 75134,
	"./add_arrow.svg": 33988,
	"./add_arrow2.svg": 88926,
	"./add_img.svg": 62594,
	"./add_imgbgc.svg": 75794,
	"./add_imgbgc2.svg": 21772,
	"./all_left-side.svg": 31582,
	"./all_right-side.svg": 20499,
	"./apply_color.svg": 70175,
	"./arrow-down.svg": 52325,
	"./arrow-next.svg": 72590,
	"./arrow-pre.svg": 3732,
	"./arrowdown.svg": 51392,
	"./arrowright.svg": 85098,
	"./attachment.svg": 50142,
	"./backtop.svg": 10713,
	"./bell.svg": 3050,
	"./buzzin.svg": 69687,
	"./change.svg": 35985,
	"./check.svg": 72179,
	"./chevron-left.svg": 68736,
	"./circle-fill.svg": 7769,
	"./circle.svg": 41773,
	"./clipboard-list.svg": 50014,
	"./close-eye.svg": 36860,
	"./close.svg": 74983,
	"./collate.svg": 82097,
	"./copy.svg": 68898,
	"./copy2.svg": 35388,
	"./cowork.svg": 47268,
	"./crown.svg": 30558,
	"./delete.svg": 55556,
	"./doc.svg": 16929,
	"./download.svg": 7137,
	"./draw-initial.svg": 65244,
	"./drawing.svg": 69289,
	"./edit.svg": 61593,
	"./ellip-fill.svg": 75041,
	"./empty-data.svg": 20017,
	"./eraser.svg": 41753,
	"./eye-hide.svg": 82781,
	"./eye-show.svg": 90318,
	"./eye.svg": 33288,
	"./file-left.svg": 72951,
	"./file-right.svg": 38354,
	"./filter.svg": 14571,
	"./fin.svg": 62640,
	"./flow.svg": 7825,
	"./folder.svg": 72417,
	"./folder3.svg": 93776,
	"./fontsize.svg": 84589,
	"./fontsize_aa.svg": 42674,
	"./forbidden.svg": 47964,
	"./grid.svg": 30457,
	"./group.svg": 5818,
	"./hamburger.svg": 42010,
	"./hi-mind.svg": 9489,
	"./hi.svg": 52236,
	"./highlighter.svg": 72242,
	"./history.svg": 5987,
	"./historyClock.svg": 71859,
	"./home.svg": 98716,
	"./home2.svg": 64134,
	"./img_upload.svg": 18906,
	"./imgbgc_upload.svg": 91594,
	"./import.svg": 69362,
	"./info.svg": 5489,
	"./irs.svg": 88843,
	"./irs5.svg": 43692,
	"./link.svg": 32873,
	"./list.svg": 77293,
	"./loading.svg": 36099,
	"./lock.svg": 86592,
	"./log_out.svg": 24028,
	"./magic.svg": 39022,
	"./medal-bronze.svg": 91715,
	"./medal-gold.svg": 69881,
	"./medal-silver.svg": 41800,
	"./microphone.svg": 46965,
	"./minus-pure.svg": 49618,
	"./minus.svg": 79719,
	"./more.svg": 62878,
	"./moveBottom.svg": 28591,
	"./moveTo.svg": 73521,
	"./moveTop.svg": 23731,
	"./music-note.svg": 37143,
	"./navigator.svg": 51904,
	"./no-color.svg": 86526,
	"./note.svg": 41909,
	"./object.svg": 8820,
	"./palette.svg": 28682,
	"./pause.svg": 8565,
	"./pen.svg": 48774,
	"./pencil-alt.svg": 99480,
	"./play.svg": 59231,
	"./plus.svg": 30985,
	"./point1.svg": 77206,
	"./point2.svg": 18453,
	"./profile.svg": 84680,
	"./pushImg.svg": 2598,
	"./qrcode.svg": 74575,
	"./rec-fill.svg": 69697,
	"./refresh.svg": 16598,
	"./refreshht.svg": 34850,
	"./robot.svg": 43959,
	"./rotationImg.svg": 36800,
	"./save.svg": 77854,
	"./scale.svg": 97797,
	"./scale_hand.svg": 16195,
	"./search.svg": 45093,
	"./select.svg": 36805,
	"./send.svg": 25531,
	"./send_img.svg": 59371,
	"./setting-game.svg": 59982,
	"./setting.svg": 22647,
	"./shap.svg": 4543,
	"./share.svg": 45130,
	"./shuffle.svg": 75960,
	"./size.svg": 88234,
	"./star-fill.svg": 36429,
	"./star.svg": 90105,
	"./stop.svg": 26237,
	"./task.svg": 5754,
	"./teacher.svg": 67281,
	"./text.svg": 91408,
	"./textNote.svg": 34764,
	"./thumbs-up.svg": 82512,
	"./tmd_circle.svg": 17075,
	"./trash.svg": 8737,
	"./tri-fill.svg": 45314,
	"./undo-arrow.svg": 94719,
	"./undo.svg": 62267,
	"./unlock.svg": 28189,
	"./upload-cloud.svg": 89738,
	"./upload.svg": 54006,
	"./video-camera.svg": 52170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;